import React from 'react';
import { CheckCircle, ChevronRight } from 'lucide-react';

const HeroBanner = ({ onOpenApplicationModal }) => {
    // Добавляем встроенные стили для элементов, которые использовали Tailwind классы
    const styles = {
        container: {
            position: 'relative',
            overflow: 'hidden'
        },
        backgroundCircle1: {
            position: 'absolute',
            right: '-4rem',
            top: '-4rem',
            width: '16rem',
            height: '16rem',
            borderRadius: '50%',
            backgroundColor: 'rgba(30, 58, 138, 0.1)' // Синий с прозрачностью
        },
        backgroundCircle2: {
            position: 'absolute',
            right: '8rem',
            bottom: '2.5rem',
            width: '8rem',
            height: '8rem',
            borderRadius: '50%',
            backgroundColor: 'rgba(30, 58, 138, 0.15)' // Синий с прозрачностью
        },
        backgroundCircle3: {
            position: 'absolute',
            left: '5rem',
            top: '10rem',
            width: '5rem',
            height: '5rem',
            borderRadius: '50%',
            backgroundColor: 'rgba(30, 58, 138, 0.08)' // Синий с прозрачностью
        },
        content: {
            position: 'relative',
            zIndex: 10,
            display: 'flex',
            flexDirection: 'column'
        },
        textSection: {
            maxWidth: '600px'
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '0.75rem',
            marginBottom: '1.5rem'
        },
        feature: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        imageSection: {
            display: 'none',
            position: 'absolute',
            right: '2rem',
            bottom: '2rem',
            maxWidth: '300px'
        },
        imageContainer: {
            position: 'relative',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            padding: '1rem',
            borderRadius: '0.5rem',
            backdropFilter: 'blur(4px)'
        },
        badge: {
            position: 'absolute',
            top: '-0.75rem',
            right: '-0.75rem',
            backgroundColor: '#f97316', // Оранжевый фон
            color: 'white', // Белый текст
            fontWeight: 'bold',
            fontSize: '0.875rem',
            padding: '0.25rem 0.75rem',
            borderRadius: '9999px'
        },
        image: {
            width: '100%',
            height: 'auto',
            borderRadius: '0.375rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        },
        imageCaption: {
            marginTop: '1rem',
            backgroundColor: 'rgba(15, 15, 15, 0.8)', // Черный фон с прозрачностью
            backdropFilter: 'blur(4px)',
            padding: '0.75rem',
            borderRadius: '0.375rem'
        },
        captionContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        captionText: {
            color: 'white'
        },
        captionTitle: {
            fontSize: '0.875rem',
            fontWeight: '500',
            color: 'rgba(255, 255, 255, 0.8)' // Белый с прозрачностью
        },
        captionSubtitle: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: 'white'
        },
        iconCircle: {
            backgroundColor: '#171717', // Черный фон
            padding: '0.5rem',
            borderRadius: '50%'
        }
    };

    // Медиа-запрос для отображения правой секции на больших экранах
    React.useEffect(() => {
        const handleResize = () => {
            const imageSection = document.getElementById('hero-image-section');
            if (imageSection) {
                if (window.innerWidth >= 1024) {
                    imageSection.style.display = 'block';
                } else {
                    imageSection.style.display = 'none';
                }
            }
        };

        handleResize(); // Вызов при монтировании
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="hero-banner" style={styles.container}>
            {/* Декоративные фоновые элементы */}
            <div style={styles.backgroundCircle1}></div>
            <div style={styles.backgroundCircle2}></div>
            <div style={styles.backgroundCircle3}></div>

            <div style={styles.content}>
                {/* Текстовый контент */}
                <div style={styles.textSection}>
                    <h2>Пригон авто под заказ из Европы</h2>
                    <h3>Германии, Бельгии, Голландии, Франции и др.</h3>
                    <p>Поможем подобрать и доставим авто из Европы автовозом с полным таможенным оформлением</p>

                    <div className="hero-features" style={styles.grid}>
                        <div className="hero-feature" style={styles.feature}>
                            <CheckCircle size={20} />
                            <span>Официальный договор</span>
                        </div>
                        <div className="hero-feature" style={styles.feature}>
                            <CheckCircle size={20} />
                            <span>Лучший сервис</span>
                        </div>
                        <div className="hero-feature" style={styles.feature}>
                            <CheckCircle size={20} />
                            <span>Доставка до 8-ми дней</span>
                        </div>
                        <div className="hero-feature" style={styles.feature}>
                            <CheckCircle size={20} />
                            <span>Гарантия юридической чистоты</span>
                        </div>
                    </div>

                    <button
                        className="button primary application-button"
                        style={styles.button}
                        onClick={onOpenApplicationModal}
                    >
                        Оставить заявку
                        <ChevronRight size={20} />
                    </button>
                </div>

                {/* Изображение справа (видно только на больших экранах) */}
                <div id="hero-image-section" style={styles.imageSection}>
                    <div style={styles.imageContainer}>
                        <div style={styles.badge}>Доставка из ЕС</div>
                        <div style={styles.imageCaption}>
                            <div style={styles.captionContent}>
                                <div style={styles.captionText}>
                                    <div style={styles.captionTitle}>Поможем подобрать</div>
                                    <div style={styles.captionSubtitle}>Авто вашей мечты</div>
                                </div>
                                <div style={styles.iconCircle}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2"/>
                                        <circle cx="6.5" cy="16.5" r="2.5"/>
                                        <circle cx="16.5" cy="16.5" r="2.5"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;